export const analytics3d = ({dispatch}) => next => (action) => {
    next(action);
}
